import React from 'react'
import SecTitleWithIconDesc from '../../components/secTitleWithIconDesc'
import SettingsIcon from '../../../../assets/icons/SettingsIcon'
import { useTheme } from '../../../../middleware/ThemeContext'
import StyledText from '../../../../components/StyledComponents/StyledText'
import StyledInput from '../../../../components/StyledComponents/StyledInput'
import { WebsiteFormValues } from '../../../../types/types'
import { SkeletonCell } from '../../../../components/SkeletonCell'

const validateConsentUrl = (value: string | undefined) => {
    const trimmedValue = value?.trim() ?? ''

    if (!trimmedValue) {
        return ''
    }

    if (/\s/.test(trimmedValue)) {
        return 'Enter a valid URL like example.com or https://example.com.'
    }

    const normalizedValue = trimmedValue.includes('://') ? trimmedValue : `https://${trimmedValue}`

    try {
        const parsedUrl = new URL(normalizedValue)
        const hostname = parsedUrl.hostname
        const domainPattern = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/

        if (!domainPattern.test(hostname)) {
            return 'Enter a valid URL like example.com or https://example.com.'
        }

        return ''
    } catch {
        return 'Enter a valid URL like example.com or https://example.com.'
    }
}

const LegalConsent = ({ companyLoading, isResponsive, setSettingConfiguration, settingConfiguration }: { companyLoading?: boolean, isResponsive?: boolean, setSettingConfiguration: React.Dispatch<React.SetStateAction<WebsiteFormValues>>, settingConfiguration: WebsiteFormValues }) => {
    const { theme } = useTheme()
    const termOfServiceError = validateConsentUrl(settingConfiguration?.termOfService)
    const privacyPolicyError = validateConsentUrl(settingConfiguration?.privacyPolicy)

    const updateConsentField = (field: 'termOfService' | 'privacyPolicy', value: string) => {
        setSettingConfiguration({
            ...settingConfiguration,
            [field]: value
        })
    }

    return (
        <div style={{ border: `1px solid ${theme.CorporateTheme.colors.border}`, borderRadius: '10px', padding: '35px 35px', backgroundColor: theme.CorporateTheme.colors.background, width: '100%' }} >
            <SecTitleWithIconDesc fontWeight={700} fontSize={isResponsive ? '16px' : '18px'} fontColor={theme.CorporateTheme.colors.primary} descfontSize={isResponsive ? '12px' : '16px'} icon={<SettingsIcon strokeWidth={2.15} size={isResponsive ? 20 : 25} color={theme.CorporateTheme.colors.primary} />} title='Legal & Consent Settings' desc='Configure  legal & consent settings for l3 portal' />
            <div className='mt-4'>
                <div className='d-flex align-items-center gap-1 mb-2'><StyledText fontSize={isResponsive ? '13px' : '14px'} fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>Term of Service</StyledText>
                    <StyledText fontSize={isResponsive ? '13px' : '14px'} fontWeight={600} textColor={theme.CorporateTheme.colors.count}>(Optional)</StyledText></div>
                {companyLoading ? <SkeletonCell height={'40px'} className='mt-2' width={"100%"} /> : <StyledInput theme={theme} placeholder='Enter URL here' style={{background:theme.CorporateTheme.colors.background}} borderColor={theme.CreateFormTheme.colors.inputBorders} className='mt-2' value={settingConfiguration?.termOfService} isInvalid={Boolean(termOfServiceError)} onChange={(e) => updateConsentField('termOfService', e.target.value)} />}
                {termOfServiceError ? <StyledText fontSize='12px' fontWeight={500} textColor='#ef4444' style={{ marginTop: '8px' }}>{termOfServiceError}</StyledText> : null}
            </div>
            <div className='mt-4'>
                <div className='d-flex align-items-center gap-1 mb-2'>
                    <StyledText fontSize={isResponsive ? '13px' : '14px'} fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>Privacy Policy</StyledText>
                    <StyledText fontSize={isResponsive ? '13px' : '14px'} fontWeight={600} textColor={theme.CorporateTheme.colors.count}>(Optional)</StyledText>
                </div>
                {companyLoading ? <SkeletonCell height={'40px'} className='mt-2' width={"100%"} /> :<StyledInput theme={theme} placeholder='Enter URL here' style={{background:theme.CorporateTheme.colors.background}} borderColor={theme.CreateFormTheme.colors.inputBorders} className='mt-2' value={settingConfiguration.privacyPolicy} isInvalid={Boolean(privacyPolicyError)} onChange={(e) => updateConsentField('privacyPolicy', e.target.value)} />}
                {privacyPolicyError ? <StyledText fontSize='12px' fontWeight={500} textColor='#ef4444' style={{ marginTop: '8px' }}>{privacyPolicyError}</StyledText> : null}
            </div>
        </div>
    )
}

export default LegalConsent
